'use strict';

var unherit = require('unherit');
var xtend = require('xtend');
var Compiler = require('./lib/compiler.js');

module.exports = stringify;
stringify.Compiler = Compiler;

function stringify(options) {
  var Local = unherit(Compiler);
  Local.prototype.options = xtend(Local.prototype.options, this.data('settings'), options);
  this.Compiler = Local;
}



//////////////////
// WEBPACK FOOTER
// ./~/remark/~/remark-stringify/index.js
// module id = 271
// module chunks = 147254134005266 182246549230831 215303740077764